import { FlexSpacer } from 'app/components/core/FlexSpacer';
import { Icon, IconSize } from 'app/components/core/Icon';

export function Header({ icon, title, children }) {
    return (
        <header>
            <Icon size={IconSize.EXTRA_SMALL} variant={icon} />
            <h3>{title}</h3>
            <FlexSpacer />
            {children}
        </header>
    );
}
